import styled from 'styled-components';

export const ParagraphStyled = styled.p`
  margin-bottom: 16px;
  padding: 0 15px;
`;
